/*jshint esversion:6 */
import React from "react";
// import Moment from 'moment';
// import Permissions from '../../../../configurations/permissions';
import ATable from "../../../common/table";
// import Constants from '../../../../configurations/constants';
// import CButton from '../../../common/connectedButton';

const SettlementTable = props => {
  const columns = [
    {
      header: "S/N",
      width: 50,
      render: row => <div>{row.index + 1}</div>
    },
    {
      header: "Log code",
      accessor: "logCode",
      render: row => {
        return row.row.logCode;
      },
      width: 90
    },

    {
      header: " Settlement Date",
      accessor: "settlementDate",
      render: row => {
        return row.row.settlementDate;
      }
    },
    {
      header: " Participant",
      accessor: "participant",
      render: row => {
        return row.row.participant;
      }
    },
    {
      header: "Role",
      accessor: "role",
      render: row => {
        return row.row.role;
      }
    },
    {
      header: "Amount",
      accessor: "amount",
      render: row => {
        return row.row.amount;
      }
    }
  ];
  return (
    <ATable
      className="-striped -highlight"
      tableData={props.settlements}
      columns={columns}
      onChange={props.onTableChange || null}
      onRowClick={ ()=> null}
      {...props}
    />
  );
};

export default SettlementTable;



// WEBPACK FOOTER //
// ./src/components/settlement/settlementRequests/settlement/settlementTable.js